import ContactUs from '@mindful-web/marko-web-contact-us/browser';
import MonoRail from '@mindful-web/marko-web-theme-monorail/browser';
import Leaders from '@mindful-web/marko-web-leaders/browser';
import PrestitialAd from '@mindful-web/marko-web-prestitial-ad/browser';
import primaryNavDropdowns from './primary-nav-dropdowns';

const BroadstreetP1EventsTracker = () => import(/* webpackChunkName: "broadstreet-p1-events-tracker" */ './broadstreet-p1-events-tracker.vue');
const FixedAdBottomHandler = () => import(/* webpackChunkName: "fixed-ad-bottom-handler" */ './fixed-ad-bottom-handler.vue');
const CompanySearch = () => import(/* webpackChunkName: "global-company-search" */ './company-search.vue');
const SectionSearch = () => import(/* webpackChunkName: "global-section-search" */ './section-search.vue');
const GlobalSponsorSlider = () => import(/* webpackChunkName: "global-sponsor-slider" */ './sponsor-slider.vue');

export default (Browser) => {
  const { EventBus } = Browser;
  Browser.register('GlobalCompanySearch', CompanySearch, { provide: { EventBus } });
  Browser.register('GlobalSectionSearch', SectionSearch, { provide: { EventBus } });
  Browser.register('GlobalBroadstreetP1EventsTracker', BroadstreetP1EventsTracker);
  Browser.register('FixedAdBottomHandler', FixedAdBottomHandler);
  Browser.register('GlobalSponsorSlider', GlobalSponsorSlider);

  ContactUs(Browser);
  MonoRail(Browser);
  Leaders(Browser);
  PrestitialAd(Browser);

  primaryNavDropdowns();
};
